import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  const updateLastLoginAtIfNeeded = async (userId: string) => {
    try {
      const userProfileRef = doc(db, 'user_profiles', userId);
      const userProfileSnap = await getDoc(userProfileRef);
      
      if (userProfileSnap.exists()) {
        const userData = userProfileSnap.data();
        const lastLoginAt = userData.lastLoginAt;
        const now = new Date();
        const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
        
        // lastLoginAt이 없거나, 1시간 이전의 기록인 경우에만 업데이트
        if (!lastLoginAt || 
            lastLoginAt === 'Invalid Date' || 
            new Date(lastLoginAt) < oneHourAgo) {
          await updateDoc(userProfileRef, {
            lastLoginAt: now.toISOString()
          });
        }
      }
    } catch (error) {
      console.error('lastLoginAt 자동 업데이트 실패:', error);
      // 업데이트 실패는 인증 플로우에 영향을 주지 않음
    }
  };

  useEffect(() => {
    const auth = getAuth();
    let lastUserId: string | null = null;
    
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      setLoading(false);
      
      // 새로운 사용자가 로그인했을 때만 lastLoginAt 업데이트
      if (user && user.uid !== lastUserId) {
        lastUserId = user.uid;
        await updateLastLoginAtIfNeeded(user.uid);
      } else if (!user) {
        lastUserId = null;
      }
    });

    return () => unsubscribe();
  }, []);

  return { user, loading };
}; 